import { cn } from "@/lib/utils";

interface LogoProps {
  collapsed?: boolean;
  className?: string;
}

export function Logo({ collapsed, className }: LogoProps) {
  return (
    <div
      className={cn(
        "rounded-lg bg-[#152642] px-3 py-3",
        collapsed && "px-2 py-2",
        className,
      )}
    >
      <img
        src="/sclogodark.png"
        alt="Switch Connect"
        className={cn(collapsed ? "h-6 w-auto" : "w-full h-auto")}
      />
    </div>
  );
}
